import { GetServerSideProps } from "next";
import Head from "next/head";
import Image from "next/image";
import EventListing from "../../../../components/event-list/EventListing";
import config from "../../../../config";
import { EcommerceEventList } from "../../../../models/Event";
import {
    Box,
    Button,
    Card,
    CardContent,
    Container,
    Grid,
    Typography,
} from "@mui/material";
import {
    getImageUrl,
    setupStyleMapFromStyleMap,
} from "../../../../utils/helpers";
import React from "react";
import ThemeStore from "../../../../stores/ThemeStore";
import ClientHeader from "../../../../components/ClientHeader";
import PageWrapper from "../../../../components/PageWrapper";
import Cart from "../../../../components/cart/Cart";
import { useCartStore } from "../../../../stores/CartStore";
import dynamic from "next/dynamic";
import RetrievePreviousOrders from "../../../../components/previous-orders/RetrievePreviousOrders";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export default function Home(props: { eventList: EcommerceEventList }) {
    React.useEffect(() => {
        if (props.eventList.newStyleMap) {
            setupStyleMapFromStyleMap(props.eventList.newStyleMap);
        }
    }, []);

    const pageTitle = `Retrieve Previous ${props.eventList.clientName} Tickets | AuthentiGATE`;

    return (
        <>
            <Head>
                <title>{pageTitle}</title>
                <meta
                    name="description"
                    content={`Buy tickets for ${props.eventList.clientName} events.`}
                />
                <meta name="robots" content="noindex" />
            </Head>
            <GoogleReCaptchaProvider reCaptchaKey="6Lc1XW4kAAAAACMuJ96qI9fgbsm03ItN2ah-fIny">
                <PageWrapper {...props} noCart>
                    <RetrievePreviousOrders {...props} />
                </PageWrapper>
            </GoogleReCaptchaProvider>
        </>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const cartUrl = context.params?.cartUrl;
    let data: any,
        error = false;
    try {
        const res = await fetch(
            `${config.BACKEND_URI}/sales/cart-style/${cartUrl}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-Sales-Context": "ECOMMERCE",
                },
            },
        );
        if (res.status !== 200) {
            error = true;
            console.log(await res.text());
        } else {
            data = await res.json();
        }
    } catch (err) {
        console.log(err);
        error = true;
    }

    if (data?.newStyleMap) {
        setupStyleMapFromStyleMap(data.newStyleMap);
    }

    return {
        props: { eventList: data },
        notFound: error,
    };
};
